<!--
 * @Description: 对账函
 * @Autor: txp
 * @Date: 2021-05-07 14:11:05
-->
<template>
  <div class="customer">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="ft20 D1D1D1">客户对账函</span>
      </div>
      <div class="flex justify_content_between mtb520">
        <div>
          <el-select
            size="small"
            v-model="customerType"
            clearable
            placeholder="请选择对账状态"
          >
            <el-option
              v-for="item in selectValList"
              :key="item.dictCode"
              :label="item.dictValue"
              :value="item.dictCode"
            >
            </el-option>
          </el-select>
          <el-date-picker
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            class="ml20"
            size="small"
            v-model="startTime"
            type="date"
            placeholder="选择对账开始时间"
          >
          </el-date-picker>
          <el-date-picker
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            class="ml20"
            size="small"
            v-model="endTime"
            type="date"
            placeholder="选择对账结束时间"
          >
          </el-date-picker>
        </div>
        <div>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-refresh-right"
            @click="queryClick"
            >查询</el-button
          >
          <el-button
            size="small"
            type="primary"
            plain
            icon="el-icon-refresh-right"
            @click="resetClick"
            >重置</el-button
          >
        </div>
      </div>
      <div>
        <el-table
          ref="customerId"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          :data="table_data"
          :header-cell-style="{
            textAlign: 'center',
            fontSize: '13px',
            color: '#787878',
            background: '#F5F5F5',
          }"
          :cell-style="{
            textAlign: 'center',
            fontSize: '14px',
            color: '#1D1D1D',
            lineHeight: '24px',
          }"
        >
          <el-table-column
            v-for="(item, index) in table_config.thead"
            :key="index"
            :prop="item.prop"
            :label="item.label"
          >
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                @click="findclick(scope.row)"
                type="text"
                size="small"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="反馈回复">
            <template slot-scope="scope">
              <el-button
                @click="drawerClick(scope.row.statementCode)"
                type="text"
                size="small"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pageschange">
        <el-pagination
          background
          layout="total,prev, pager, next"
          :total="total"
          :current-page.sync="pageNum"
          prev-text="上一页"
          next-text="下一页"
          @current-change="controllerList()"
        >
          <!-- @next-click="nextClick"
                @prev-click="prevClick" -->
        </el-pagination>
      </div>
    </el-card>
    <div v-if="visible">
      <DialogCom
        :titles="title"
        :visible.sync="visible"
        :dataInfo="dataInfo"
        @updateVisible="updateVisible"
        @submitPopupData="submitPopupData"
        @handleClose="handleClose"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex"; //主题的引用
import {
  CustomerStatementControllerList,
  QueryDataByStatementId,
} from "@/api/customer";
import { mdmdictdata } from "@/api/api";
import DialogCom from "./components/DialogCom";
export default {
  name: "customer",
  data() {
    return {
      visible: false,
      total: 0,
      pageSize: 10,
      pageNum: 1,
      title: "反馈信息",
      customerType: "", //对账状态
      startTime: "", //对账开始时间
      endTime: '',//对账结束时间
      selectValList: [], //对账状态数组
      table_config: {
        thead: [
          { label: "对账开始时间", prop: "startTime" },
          { label: "对账结束时间", prop: "endTime" },
          { label: "对账状态", prop: "customerStatement" },
        ],
      },
      loading: true,
      table_data: [],
      dataInfo: {}, //获取弹框反馈信息内容
    };
  },
  components: {
    DialogCom,
  },
  computed: {
    ...mapGetters({
      theme: "theme",
    }),
  },
  mounted() {
    this.controllerList();
  },
  methods: {
    // 获取数据字典
    async mdmdictdatas() {
      await mdmdictdata({
        dictTypeCode: "dms_hd_customer_statement_status",
      })
        .then((res) => {
          if (res.code == 200) {
            this.selectValList = res.result;
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    // 获取对账函列表
    controllerList() {
      this.loading = true;
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        startTime: this.startTime,
        endTime: this.endTime,
        customerStatementStatus: this.customerType,
      };
      CustomerStatementControllerList({ ...params }).then(async (res) => {
        await this.mdmdictdatas(); //请求
        let companyData = res.result.data.map((item) => {
          let obj = {};
          obj.customerStatement = item.customerStatementStatus
            ? this.selectValList.find(
                (it) => it.dictCode === item.customerStatementStatus
              ).dictValue
            : item.customerStatementStatus;
          obj.id = item.id;
          obj.startTime = item.startTime;
          obj.endTime = item.endTime;
          obj.statementCode = item.statementCode;
          return obj;
        });
        this.total = res.result.count;
        this.table_data = companyData;
        this.loading = false;
      });
    },
    // 查看对账函详情
    findclick(row) {
      this.$router.push({
        path: "/home/main/reconletter",
        query: {
          statementCode:row.statementCode,
          id: row.id
        },
      });
    },
    // 查看反馈信息
    drawerClick(statementCode) {
      this.visible = true;
      QueryDataByStatementId({statementCode})
        .then((res) => {
          if (res.code == 200) {
            this.dataInfo = res.result;
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    // 查询
    queryClick() {
      // this.loading = true
      this.controllerList();
    },
    // 重置
    resetClick() {
      // this.loading = true
      this.pageNum = 1;
      this.pageSize = 10;
      this.selectDateValue = "";
      this.customerType = "";
      this.controllerList();
    },
    // 监听弹框得变化
    updateVisible(val) {
      this.visible = val;
    },
    handleClose(val) {
      this.visible = val;
    },
    submitPopupData(val) {
      this.visible = val;
    },
    //  // 分页处理
    //   nextClick(nextPageNum){
    //       this.loading = true
    //       this.pageNum=nextPageNum
    //       this.controllerList()
    //   },
    //   prevClick(prevPageNum){
    //       this.loading = true
    //       this.pageNum=prevPageNum
    //       this.controllerList()
    //   },
    //   currentClick(currentPageNum){
    //       this.loading = true
    //       this.pageNum=currentPageNum
    //       this.controllerList()
    //   }
  },
};
</script>
<style lang="scss" scoped>
.customer {
  height: 100%;
  /deep/.el-card {
    height: 100%;
    .el-card__header {
      border-bottom: 0;
      padding: 20px 20px 0px 20px;
    }
    // 选择框图标
    .el-icon-arrow-up:before {
      content: "\e790";
    }
    .el-input__inner {
      border-radius: 2px;
      background: #f5f5f5;
    }
    .el-range-editor.el-input__inner {
      width: 150px;
    }
    .el-range-input {
      background: #f5f5f5;
    }
    //分页
    .pageschange {
      margin: 20px auto;
      text-align: center;
    }
  }
}
</style>
